import { container } from "./material-kit-react.js";

const signupPageStyle = {
  container: {
    ...container,
    zIndex: "2",
    //position: "relative",
    //paddingTop: "20vh",
    color: "#FFFFFF",
    //paddingBottom: "200px",
    justifyContent: "center",
    overflow: "auto",
    maxHeight: "calc(100vh - 200px)",
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)",
  },
  pageHeader: {
    //minHeight: "100vh",
    //minHeight: "calc(100vh - 200px)",
    height: "auto",
    display: "inherit",
    position: "relative",
    margin: "-8px",
    padding: "0",
    border: "0",
    alignItems: "center",
    "&:before": {
      background: "rgba(0, 0, 0, 0.5)",
    },
    "&:before,&:after": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: '""',
    },
    "& footer li a,& footer li a:hover,& footer li a:active": {
      color: "#FFFFFF",
    },
    "& footer": {
      position: "absolute",
      bottom: "0",
      width: "100%",
    },
  },
  form: {
    margin: "0",
  },
  cardHeader: {
    width: "auto",
    textAlign: "center",
    marginLeft: "20px",
    marginRight: "20px",
    marginTop: "-40px",
    padding: "5px 0",
    marginBottom: "15px",
  },
  socialIcons: {
    maxWidth: "24px",
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px",
  },
  divider: {
    marginTop: "30px",
    marginBottom: "0px",
    textAlign: "center",
  },
  cardFooter: {
    paddingTop: "0rem",
    border: "0",
    borderRadius: "6px",
    justifyContent: "center !important",
  },
  socialLine: {
    marginTop: "1rem",
    textAlign: "center",
    padding: "0",
  },
  inputIconsColor: {
    color: "#495057",
  },
  forgotButton: {
    margin: 0,
    marginTop: "-20px",
    textTransform: "none",
    padding: "0 0",
    color: "#828282",
    fontSize: 10,
  },
  normalButton: {
    width: "100%",
    margin: 0,
    marginTop: "10px",
    backgroundColor: "#fd576b",
    border: "solid 1px #fff",
    borderRadius: 15,

    "& p": {
      color: "#fff",
    },
    "&:hover": {
      backgroundColor: "#fff",
      border: "solid 1px #fd576b",
      borderRadius: 15,
    },
    "&:hover p": {
      color: "#fd576b",
    },
    "&:focus": {
      backgroundColor: "#fff",
      border: "solid 1px #fd576b",
      borderRadius: 15,
    },
    "&:focus p": {
      color: "#fd576b",
    },
  },
  buttonContainer: {
    width: "100%",
  },

  normalButton2: {
    width: "100%",
    margin: 0,
    marginTop: "10px",
    backgroundColor: "#004d8b",
    border: "solid 1px #fff",
    borderRadius: 15,

    "& p": {
      color: "#fff",
    },
    "&:hover": {
      backgroundColor: "#fff",
      border: "solid 1px #004d8b",
      borderRadius: 15,
    },
    "&:hover p": {
      color: "#004d8b",
    },
  },

  inputRtl: {
    "& label": {
      transformOrigin: "top left",
      right: 28,
      left: "auto",
    },
    "& legend": {
      textAlign: "right",
    },
  },
};

export default signupPageStyle;
